import { ClassAssignmentStatus } from './class-assignment.model';

export const ASSIGNMENT_SLUG_PARAM = 'assignmentSlug';

export const STATUS_LABELS: Record<ClassAssignmentStatus, string> = {
  DRAFT: 'assignments.status.draft',
  SCHEDULED: 'assignments.status.scheduled',
  PUBLISHED: 'assignments.status.published',
};

export const STATUS_COLOR_CLASSES: Record<ClassAssignmentStatus, string> = {
  DRAFT: 'bg-neutral-100 text-neutral-600',
  SCHEDULED: 'bg-amber-100 text-amber-700',
  PUBLISHED: 'bg-sky-100 text-sky-600',
};

export const STATUS_OPTIONS: Array<{ value: ClassAssignmentStatus; labelKey: string }> = (
  Object.keys(STATUS_LABELS) as ClassAssignmentStatus[]
).map((status) => ({
  value: status,
  labelKey: STATUS_LABELS[status],
}));
